export default __webpack_public_path__ + "static/media/background.76ae6554.jpg";